var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.94,
    height: 74.94,
    viewBox: "0 0 74.94 74.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(-271.283 -84.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M321.24,111.166A2.244,2.244,0,1,1,319,108.921,2.245,2.245,0,0,1,321.24,111.166Zm-2.795,10.062a9.428,9.428,0,1,1-9.428-9.428A9.439,9.439,0,0,1,318.445,121.228Zm-3.388,0a6.04,6.04,0,1,0-6.04,6.04A6.047,6.047,0,0,0,315.057,121.228Zm13.044-7.574a11.5,11.5,0,0,0-11.5-11.5H300.907a11.5,11.5,0,0,0-11.5,11.5v15.694a11.5,11.5,0,0,0,11.5,11.5H316.6a11.5,11.5,0,0,0,11.5-11.5Zm-3.776,15.521a7.9,7.9,0,0,1-7.9,7.9H301.08a7.9,7.9,0,0,1-7.9-7.9V113.827a7.9,7.9,0,0,1,7.9-7.9h15.347a7.9,7.9,0,0,1,7.9,7.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M308.753,84.031a37.47,37.47,0,1,0,37.47,37.47A37.512,37.512,0,0,0,308.753,84.031Zm0,70.135A32.665,32.665,0,1,1,341.418,121.5,32.7,32.7,0,0,1,308.753,154.166Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.a5b70cf9c5392180c10d33ef5e670dfa.svg";
export { ForwardRef as ReactComponent };